import * as React from 'react';
import {
  ParagraphText,
  GDSBackgroundColor,
} from '@leagueplatform/genesis-core';
import { useUniqueId } from '@leagueplatform/web-common';
import { Table } from '@leagueplatform/genesis-core-alpha';

type HeaderBackgroundColor = GDSBackgroundColor;

interface Header {
  name: string;
  id: string;
}

interface Row {
  row: string[];
}

export interface CoverageTable {
  tableName: string;
  hasBorder?: boolean;
  headerBackgroundColor?: HeaderBackgroundColor;
  headers: Header[];
  rows: Row[];
}

export const TableComponent: React.FC<{ table: CoverageTable }> = ({
  table,
}) => {
  const {
    tableName,
    hasBorder = true,
    headerBackgroundColor = 'secondary',
    headers,
    rows,
  } = table;

  const uniqueId = useUniqueId();

  if (!headers?.length || !rows?.length) return null;

  return (
    <Table tableName={tableName} border={hasBorder} isResponsive>
      <Table.Head>
        <Table.Row>
          {headers.map((header: Header) => (
            <Table.Header
              key={header.id}
              label={header.name}
              backgroundColor={headerBackgroundColor}
            />
          ))}
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {rows.map((row: Row, rowIndex: number) => (
          <Table.Row
            // eslint-disable-next-line react/no-array-index-key
            key={`${uniqueId}-${rowIndex}`}
          >
            {row.row.map((cell: string, cellIndex: number) => (
              // eslint-disable-next-line react/no-array-index-key
              <Table.Cell key={`${uniqueId}-${rowIndex}-${cellIndex}`}>
                <ParagraphText>{cell}</ParagraphText>
              </Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};
